import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=61782745&scoped=true&"
import script from "./orderResult.vue?vue&type=script&lang=js&"
export * from "./orderResult.vue?vue&type=script&lang=js&"
import style0 from "./orderResult.vue?vue&type=style&index=0&id=61782745&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61782745",
  null
  
)

export default component.exports